import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useSocialProfiles } from "../hooks/useSocialProfiles";

import FacebookIcon from "../images/icons/facebook.svg";
import InstagramIcon from "../images/icons/instagram.svg";
import LinkedInIcon from "../images/icons/linkedin.svg";
import YouTubeIcon from "../images/icons/youtube.svg";

import "../styles/components/SocialProfiles.scss";

const icons = {
    facebook: <FacebookIcon />,
    instagram: <InstagramIcon />,
    linkedin: <LinkedInIcon />,
    youtube: <YouTubeIcon />,
};

const SocialProfiles = ({ className }) => {
    const socialProfiles = useSocialProfiles();

    return (
        <div className={classNames("social-profiles", className)}>
            {socialProfiles.map(({ network, url }) => (
                <a
                    href={url}
                    className={`social-profiles-profile social-profiles-${network}`}
                    rel="noreferrer"
                    key={url}
                    aria-label={network}
                >
                    {icons[network]}
                </a>
            ))}
        </div>
    );
};

SocialProfiles.propTypes = {
    className: PropTypes.string,
};

export default SocialProfiles;
